// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c0227118","453":"468b1fbb","455":"97eda835","977":"ac2bfd3d"}[chunkId] + ".chunk.js";
};